var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPersonCropCircle = function SvgPersonCropCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "person-crop-circle_svg__icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.997 14.563c3.599 0 6.57-2.97 6.57-6.563 0-3.593-2.977-6.563-6.577-6.563-3.592 0-6.557 2.97-6.557 6.563 0 3.593 2.971 6.563 6.564 6.563Zm0-4.367c-1.79 0-3.18.641-3.853 1.378A5.243 5.243 0 0 1 2.754 8c0-2.914 2.33-5.25 5.236-5.25A5.246 5.246 0 0 1 13.253 8c0 1.384-.527 2.64-1.397 3.58-.673-.743-2.063-1.384-3.86-1.384Zm0-1.04c1.231.012 2.19-1.042 2.19-2.4 0-1.282-.965-2.355-2.19-2.355-1.219 0-2.19 1.073-2.184 2.355.007 1.358.959 2.393 2.184 2.4Z",
    fill: "currentColor"
  })));
};

export default SvgPersonCropCircle;